<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <strong>{{$t('InventoryBill')}}</strong>
              </CCol>
              <CCol  style="text-align: end;">
                <!--                <CButton @click="AddAllRefer()" size="sm" color="primary">-->
                <!--                  {{ $t('components.referSelected') }}-->
                <!--                </CButton>-->
              </CCol>

            </CRow>
            <CRow>
              <CCol col="3">
                <date-picker
                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>

            </CRow>

          </CCardHeader>
          <CCardBody>


            <CDataTable
                :items="items_buy"
                :fields="fields"
                column-filter
                :items-per-page="20"
                hover
                @row-clicked="table_row_clicked"

                sorter
                pagination
            >
              <template #row="{item,index}">

                <td>
                  <p >{{ index + 1 }}</p>

                </td>

              </template>

              <template #orderDate="{item}">

                <td>
                  {{ get_date(item.createdAt) }}

                </td>


              </template>

              <template #price="{item}">

                <td>
                  <p  style="float: right" >{{ get_currency(get_total_price(item)) }}</p>
                </td>


              </template>

              <template #select-header="{item}">
                <input type="checkbox" v-model="check_all_exit"
                />
              </template>
              <template #select="{item}">
                <td>
                  <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                         :value="item.masterId"/>
                </td>
              </template>


            </CDataTable>

          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

    <CModal
        :show.sync="show_factor_detail"
        :no-close-on-backdrop="true"
        :centered="true"
        :title="$t('requestDetail')"
        size="lg"
        color="dark"
    >
<CRow>
  <CCol col="6">{{$t('date')}}: {{get_date(selected_master.createdAt)}}</CCol>
  <CCol col="6">{{$t('createdBy')}}: {{selected_master.createdBy}}</CCol>
  <CCol col="6">{{$t('orderId')}}: {{selected_master.masterCode}}</CCol>
  <CCol col="6">{{$t('supplier')}}: {{selected_master.supplierName}}</CCol>
</CRow>
      <CDataTableFixed
          :items="selected_factor"
          :fields="factor_product_fields"
          column-filter
          :items-per-page="200"
          hover
          sorter
          pagination
      >
        <template #row="{item,index}">

          <td>
            <p >{{ index + 1 }}</p>

          </td>

        </template>
        <template #received_qty="{item,index}">
          <td>
            <CInput class="m-0 p-0" v-model="item.received_qty"/>
          </td>
        </template>

        <template #select-header="{item}">
          <input type="checkbox" v-model="check_all_exit"
          />
        </template>
        <template #select="{item}">
          <td>
            <input type="checkbox" ref="permissions[]" @change="select_box_changed(item)" v-model="id_checkbox_items"
                   :value="item.id"/>
          </td>
        </template>
        <template #branch="{item}">
          <td>
           <CSelect :options="place_items"
                    :value.sync="item.place"/>
          </td>
        </template>
        <template #inventory_place="{item}">
          <td>
            <treeselect
                    :appendToBody="true"
                    v-model="item.place_row"

                    :options="item.place_rows"
                    :normalizer="normalizer_place_rows"

            />
          </td>
        </template>

      </CDataTableFixed>

      <template #footer>
        <CButton @click="accept_factor"
:disabled="!id_checkbox_items.length"
                 color="secondary"
        >{{$t('sendToBuy')}}
        </CButton>
        <CButton
            @click="show_factor_detail = false"
            color="success"
        >{{ $t("buttons.close") }}
        </CButton>
      </template>
    </CModal>

  </div>

</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import Vue from "vue";

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
var items_data = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      // show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',
      show_factor_detail: false,
      check_all_exit: false,

      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_template: 0,
      id_checkbox_items: [],
      item_sell_array: [],
      items_buy: [],
      selected_factor: [],
      selected_master:{},
      factor_product_fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'productCode', label:this.$t('components.productCode'), _style: 'width:10%'},
        {key: 'productName', label:this.$t('components.productName'), _style: 'width:20%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%'},
        // {key: 'price', label: "مبلغ", _style: 'width:15%'},
        {key: 'select', label: this.$t('tables.select'),filter:false, _style: 'width:3%'},

        {key: 'received_qty', label: this.$t('received'), _style: 'width:5%'},
        {key: 'branch', label: this.$t('inventory'), _style: 'width:15%'},
        {key: 'inventory_place', label: this.$t('inventoryPlace'), _style: 'width:15%'},
        // {key: 'supplierName', label: "تامین کننده", _style: 'width:15%'},

      ],
      fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'orderDate', label:  this.$t('orderDate'), _style: 'width:15%'},
        {key: 'masterCode', label: this.$t('orderId'), _style: 'width:10%'},
        {key: 'supplierName', label: this.$t('supplier'), _style: 'width:15%'},

        // {key: 'price', label: "مبلغ سفارش", _style: 'width:15%'},
        {key: 'supplierPhone', label: this.$t('supplierNumber') , _style: 'width:15%'},

        // {key: 'select', label: "", _style: 'width:3%', filter: false},
      ],

      table_clicks: 0,
      table_clicks_timer: null,
      details: [],
      place_items: [],
      status_form: 0,
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', true);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },
      normalizer_place_rows(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },

    }
  }, mounted() {

    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();
this.get_branches();
    this.$root.root_validate_errors = [];

    this.get_all_data();
    bus.$on('update_orders', (data) => {
      this.get_all_data()
    });

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'check_all_exit': function () {
      if (this.check_all_exit) {
        this.id_checkbox_items = [];

        this.selected_factor.forEach((val) => {
          this.id_checkbox_items.push(val.id);
        });
      } else {
        this.id_checkbox_items = [];
      }
    },
    '$route.params.person_id': function () {
      // this.get_all_data();
    },
    'start_date': function () {
      this.get_all_data();
    },
    'end_date': function () {
      this.get_all_data();
    }
  },
  methods: {
    select_box_changed(item){
      if(this.id_checkbox_items.includes(item.id)){
        console.log('checkbox_called', true);
item.received_qty = item.qty;
      }
    },
    get_total_price(item) {
      var total_price = 0
      item.details.forEach((val) => {
        total_price = total_price + (val.price * val.qty)
      });
      return total_price;
    },
    get_all_data() {
      this.get_lists_buy();

    },
    get_branches() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetPlaces', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.place_items = [];
          var obj = {label: self.$t('dialogs.choose'), value: 0}
          self.place_items.push(obj);

          self.place_items = self.sort_array(
                  self.place_items, content_data.data,
                  'id','placeName');

          // self.selected_branch = self.place_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
              .catch(function (error) {

                console.log(error);
              });

    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.selected_factor = item.details;
        this.selected_master = item;
        this.show_factor_detail = true;
        this.table_clicks = 0

        this.status_form = item.masterId;
        this.id_checkbox_items= []
      }

    },
    accept_factor() {
      var self = this;


    var details = [];
    var validate = true;
      this.id_checkbox_items.forEach((val) => {
     var detail = this.selected_factor.filter(x=> x.id = val)[0]
        if(!detail.received_qty || !detail.place){

          validate =  false
        }

         var obj = {SupplierId:this.selected_master.supplierId,
           OrderMasterId:detail.masterId,
           OrderDetailId:detail.id,
           PlaceId:detail.place,
           ProductId:detail.productId,
           Qty:detail.received_qty,
           Price:detail.price,
           TotalPrice:detail.qty*detail.price,
           Summary:detail.summary,
         }
   details.push(obj)

      });

      if(validate==false){
        this.$root.modal_component.show_validate_errors([this.$t('fillAllFields')])
        return true;
      }
      var model = {Details:details}

      const formData = new FormData();
      var url = "AddPurchaseOrderFactor";
      formData.append("input", JSON.stringify(model));

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.get_lists_buy();
          self.$root.modal_component.show_api_response_modals(response);
          self.show_factor_detail = false

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });


    },
    get_lists_buy() {
      var self = this;


      const formData = new FormData();
      var url = "GetPurchaseOrders";
      formData.append("docType", 1);
      if (self.$route.params.person_id != null) {
        formData.append("PersonId", self.$route.params.person_id);

      } else {
        formData.append("PersonId", 0);
      }
      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.items_buy = content_data.data.map((item, row_id) => {
          //   return {...item, row_id}
          //
          // });
          var factors = content_data.data;
          factors = factors.filter(x => x.isAccept == 1 && x.preFactorCode== null)
          self.items_buy = factors;
          factors.forEach((val) => {
            val.details.forEach((val2) => {

              val2.supplierName = val.supplierName;
              // val2.supplier_list = [{userName: val2.supplierName, userId: val2.supplierId}]
              // self.items_buy.push(val2)
            });
          });

          // setTimeout(() => {
          //   var factors = content_data.data;
          //   factors = factors.filter(x => x.isAccept == 0)
          //   self.items_buy = [];
          //   factors.forEach((val) => {
          //     val.details.forEach((val2) => {
          //
          //       val2.suuplier_sync = true;
          //       val2.supplier_list = [{userName: val2.supplierName, userId: val2.supplierId}]
          //       self.items_buy.push(val2)
          //     });
          //   });


          // }, 1000);

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },

    goReturnDocument(item) {
      this.$router.push({
        path: '/dashboard/documents/return/' + item.recId + "/false",
        params: {passed_data: "salam hamidddd"}
      });
    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.recId});
    },
    goPrintDocument(item) {
      bus.$emit("print_confirm", item.recId);


    },
    AddRefer(item) {
      this.submit_refer = item.recId;
    },

    AddAllRefer() {
      this.submit_refer = -1;
      if (this.id_checkbox_items.length == 0) {
        console.log("validate form is false" + this.validate_errors);
        this.submit_refer = 0;

      }
    },


  },

}

</script>
